import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";
import axios from "axios";

const api = new APIClient();

// Create a separate axios instance for import operations to bypass interceptors
const importAxios = axios.create();

// Add request interceptor for authentication
importAxios.interceptors.request.use((config) => {
  return config;
});

export const getIndividuals = (params: any) =>
  api.get(url.GET_INDIVIDUALS, params);
export const getIndividual = (id: any, params: any) => {
  const populate: any = [
    "payments",
    "payments.mda",
    "payments.positionType",
    "payments.paymentCategory",
    "payments.mda.region",
    "payments.agency",
    "createdby",
    "createdby.agency",
    "updatedby",
    "updatedby.agency",
  ];
  if (!params?.populate) params.populate = populate;
  return api.get(url.GET_INDIVIDUAL + "/" + id, params);
};
export const addIndividual = (data: any) =>
  api.create(url.ADD_INDIVIDUAL, data);
export const importIndividual = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => {
  return importAxios
    .post(process.env.REACT_APP_API_URL + url.IMPORT_INDIVIDUAL, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      timeout: options?.timeoutMs ?? 5 * 60 * 1000,
      responseType: "blob",
    })
    .then((response) => {
      // Get the X-Metadata header if it exists
      const metadata = response.headers["x-metadata"];
      let parsedMetadata = null;

      // Try to parse the metadata if it exists
      if (metadata) {
        try {
          parsedMetadata = JSON.parse(metadata);
        } catch (e) {
          parsedMetadata = metadata;
        }
      }

      // Return both the blob and metadata
      return {
        blob: response.data,
        metadata: parsedMetadata,
      };
    })
    .catch(async (error) => {
      // Handle blob error responses
      if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const errorData = JSON.parse(text);
          error.response.data = errorData;
        } catch (e) {
          // If we can't parse it, leave it as is
        }
      }
      throw error;
    });
};
export const updateIndividual = (id: any, data: any) =>
  api.put(url.UPDATE_INDIVIDUAL + "/" + id, data);
export const deleteIndividual = (id: any) =>
  api.delete(url.DELETE_INDIVIDUAL + "/" + id);
export const deleteAllIndividuals = (params: any) =>
  api.delete(url.DELETE_ALL_INDIVIDUALS, params);
export const exportIndividualsToCSV = (params: any) =>
  api.get(url.EXPORT_INDIVIDUALS_TO_CSV, params, {
    responseType: "blob",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const exportAgencyIndividualsToCSV = (params: any) =>
  api.get(url.EXPORT_AGENCY_INDIVIDUALS_TO_CSV, params, {
    responseType: "blob",
  });
export const getIndividualAgencies = (id: any) =>
  api.get(url.GET_INDIVIDUAL_AGENCIES + "/" + id + "/agencies");

export const getAgencyIndividuals = (params: any) =>
  api.get(url.GET_AGENCY_INDIVIDUALS, params);
export const getAgencyIndividual = (id: any, params: any) => {
  const populate: any = [
    "payments",
    "payments.mda",
    "payments.positionType",
    "payments.paymentCategory",
    "payments.mda.region",
    "createdby",
    "createdby.agency",
    "updatedby",
    "updatedby.agency",
  ];
  if (!params?.populate) params.populate = populate;
  return api.get(url.GET_AGENCY_INDIVIDUAL + "/" + id, params);
};
export const addAgencyIndividual = (data: any) =>
  api.create(url.ADD_AGENCY_INDIVIDUAL, data);
export const updateAgencyIndividual = (id: any, data: any) =>
  api.put(url.UPDATE_AGENCY_INDIVIDUAL + "/" + id, data);
export const deleteAgencyIndividual = (id: any) =>
  api.delete(url.DELETE_AGENCY_INDIVIDUAL + "/" + id);
